import { makeRequest } from "./baseApi";
import { cutOutHeaders, normalizeSubsContent } from "../utils/content/content";
import {parseResponseDefault} from "./not-sorted.utils";

export const getCalendarForMonth = (year, month) => {
  return makeRequest({
    url: `subscriptions/content/month/${year}/${month}`,
    type: "GET",
    parseResponse: parseResponseDefault
  });
};

export const getSubscriptions = () => {
  return makeRequest( {
    url: "subscriptions/subscriptions",
    type: "get",
    parseResponse: parseResponseDefault
  });
};

export const deleteSubscription = (id) => {
  return makeRequest({
    url: `subscriptions/subscriptions/${id}`,
    type: "delete",
    parseResponse: (response) => response.status, 
  });
};

export const getSubsContentForDate = (date) => {
  const request = {
    url: `subscriptions/content/${date}`,
    type: "GET",
    parseResponse: parseResponseDefault
  };
  return makeRequest(request);
};

export const fetchContentByDateRequest = async (date) => {
  try {
    const response = await getSubsContentForDate(date);

    return { [date]: cutOutHeaders(normalizeSubsContent(response.subscriptions)) };
  } catch (error) {
    return null;
  }
};

export const getThoughtsByDate = (date) => { 
  return makeRequest({
    url: `subscriptions/thought?date=${date}`,
    type: "GET",
    parseResponse: parseResponseDefault
  });
};

export const fetchThoughtsByDateRequest = async (date) => {
  try {
    const response = await getThoughtsByDate(date);

    return { [date]: response };
  } catch (error) {
    return null;
  }
};
